import React, { FC } from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import { Modal } from 'components/atoms/modal';
import { useTranslation } from 'hooks/use-translation';

export const ProjectSettingsPrompt: FC<{
  isDirty: boolean;
  onReset: () => void;
}> = ({ isDirty, onReset }) => {
  const unsavedChangesTitle = useTranslation(
    'templates.confirm.unsaved_changes_title',
  );
  const unsavedChangesText = useTranslation(
    'templates.confirm.unsaved_changes_text',
  );
  const okButtonText = useTranslation('templates.confirm.unsaved_changes_ok');
  const cancelButtonText = useTranslation(
    'templates.confirm.unsaved_changes_cancel',
  );

  return (
    <NavigationPrompt when={isDirty} afterConfirm={onReset}>
      {({ isActive, onCancel, onConfirm }) => {
        if (isActive) {
          return (
            <Modal
              title={unsavedChangesTitle}
              visible
              onOk={onConfirm}
              onCancel={onCancel}
              okText={okButtonText}
              okType="danger"
              cancelText={cancelButtonText}
            >
              <p>{unsavedChangesText}</p>
            </Modal>
          );
        }

        return <></>;
      }}
    </NavigationPrompt>
  );
};
